<p>{{'account.go_buy_licence_body' + role | translate}}</p>
<button mat-raised-button *ngIf="data?.isInSnackbar" (click)="dismiss()" class="mat-accent">
    {{ 'account.go_buy_licence_ok' + role | translate }}
</button>
<a mat-raised-button class="mat-accent" [href]="'navigation.external-target-link-menu-url' | translate">
    {{ 'account.go_buy_licence_link' + role | translate }}
</a>
